var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MyADGMeetings/MyADGMeetingsInner.jinja"] = require( "front/components/MyADGMeetings/MyADGMeetingsInner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGMeetings/MyADGMeetings.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGMeetings/MyADGMeetings.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MyADGMeetings/MyADGMeetingsInner.jinja", false, "assets/app/front/components/MyADGMeetings/MyADGMeetings.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MyADGMeetingsInner")) {
var t_7 = t_4.MyADGMeetingsInner;
} else {
cb(new Error("cannot import 'MyADGMeetingsInner'")); return;
}
context.setVariable("MyADGMeetingsInner", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"MyADGMeetings\">\n        <h2>ADG MEETINGS</h2>\n        <figure>\n            <figcaption>";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"previewRendered")), env.opts.autoescape);
t_9 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list"))) {
t_9 += "<button class=\"MyADGMeetings-meetingMinutesButton\">Meeting Minutes</button>";
;
}
t_9 += "</figcaption>\n            <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_9 += "\"\n              srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w1366_url"), env.opts.autoescape);
t_9 += " 1366w,\n                      ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_9 += " 680w\"\n              sizes=\"(max-width: 759px) 1, ";
t_9 += "\n                     100vw\"\n              alt=\"\">\n        </figure>\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list"))) {
t_9 += "\n            <div class=\"MyADGMeetings-meetingMinutesCategories\">\n                <div class=\"MyADGMeetings-meetingMinutesCategories-content\">\n                    <div class=\"MyADGMeetings-meetingMinutesCategories-close\">\n                        ";
t_9 += runtime.suppressValue((lineno = 21, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["panel-close","0 0 40 40",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_9 += "\n                    </div>\n                    <h3>MEETING MINUTES</h3>\n                    <ul class=\"MyADGMeetings-meetingMinutesCategories-list\">\n                    ";
frame = frame.push();
var t_14 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("category", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
if(env.getFilter("length").call(context, runtime.memberLookup((t_15),"list"))) {
t_9 += "\n                            <li>\n                                <div class=\"MyADGMeetings-meetingMinutesCategories-listItem\" data-id=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_15),"id"), env.opts.autoescape);
t_9 += "\" data-title=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_15),"title"), env.opts.autoescape);
t_9 += "\">\n                                    <div class=\"MyADGMeetings-meetingMinutesCategories-listItemTitle\">";
t_9 += runtime.suppressValue(runtime.memberLookup((t_15),"title"), env.opts.autoescape);
t_9 += "</div>\n                                    <div class=\"MyADGMeetings-meetingMinutesCategories-listItemUpdated\">";
if(runtime.memberLookup((t_15),"updated")) {
t_9 += "last updated ";
t_9 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_15),"updated"),"%m/%d/%Y"), env.opts.autoescape);
;
}
t_9 += "</div>\n                                    <div class=\"MyADGMeetings-meetingMinutesCategories-listItemArrow\">\n                                        ";
t_9 += runtime.suppressValue((lineno = 36, colno = 62, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_17 = "";;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
t_9 += "\n                                    </div>\n                                </div>\n                            </li>\n                        ";
;
}
t_9 += "\n                    ";
;
}
}
frame = frame.pop();
t_9 += "</ul>\n                </div>\n            </div>\n\n            <div class=\"MyADGMeetings-meetingMinutes\">\n                <div class=\"MyADGMeetings-meetingMinutes-table\">\n                    <div class=\"MyADGMeetings-meetingMinutes-cell\">\n                        <div class=\"MyADGMeetings-meetingMinutes-content\">\n                            <div class=\"MyADGMeetings-meetingMinutes-close\">\n                                ";
t_9 += runtime.suppressValue((lineno = 51, colno = 54, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["panel-close","0 0 40 40",runtime.makeKeywordArgs({"caller": (function (){var macro_t_18 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_19 = "";;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
return macro_t_18;})()})])), env.opts.autoescape);
t_9 += "\n                            </div>\n                            <div class=\"MyADGMeetings-meetingMinutes-mobileScrollBox\">\n                                <div class=\"MyADGMeetings-meetingMinutes-header\">\n                                    <h3>MEETING MINUTES</h3>\n                                    <div class=\"MyADGMeetings-meetingMinutes-headerText\">";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"text")), env.opts.autoescape);
t_9 += "</div>\n                                </div>\n                                <div class=\"MyADGMeetings-meetingMinutes-scrollBlock\">\n                                    <div class=\"MyADGMeetings-meetingMinutes-inner\">\n                                        <ul class=\"MyADGMeetings-meetingMinutes-list\">\n                                        ";
frame = frame.push();
var t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"meetingMinutes")),"list");
if(t_22) {t_22 = runtime.fromIterator(t_22);
var t_21 = t_22.length;
for(var t_20=0; t_20 < t_22.length; t_20++) {
var t_23 = t_22[t_20];
frame.set("category", t_23);
frame.set("loop.index", t_20 + 1);
frame.set("loop.index0", t_20);
frame.set("loop.revindex", t_21 - t_20);
frame.set("loop.revindex0", t_21 - t_20 - 1);
frame.set("loop.first", t_20 === 0);
frame.set("loop.last", t_20 === t_21 - 1);
frame.set("loop.length", t_21);
frame = frame.push();
var t_26 = runtime.memberLookup((t_23),"list");
if(t_26) {t_26 = runtime.fromIterator(t_26);
var t_25 = t_26.length;
for(var t_24=0; t_24 < t_26.length; t_24++) {
var t_27 = t_26[t_24];
frame.set("item", t_27);
frame.set("loop.index", t_24 + 1);
frame.set("loop.index0", t_24);
frame.set("loop.revindex", t_25 - t_24);
frame.set("loop.revindex0", t_25 - t_24 - 1);
frame.set("loop.first", t_24 === 0);
frame.set("loop.last", t_24 === t_25 - 1);
frame.set("loop.length", t_25);
t_9 += "<li data-category-id=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_23),"id"), env.opts.autoescape);
t_9 += "\">\n                                                    <a class=\"MyADGMeetings-meetingMinutes-listItem\" href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_27),"pdf"), env.opts.autoescape);
t_9 += "\">\n                                                        <div class=\"MyADGMeetings-meetingMinutes-listItemDate\">";
if(runtime.memberLookup((t_27),"date")) {
t_9 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_27),"date"),"%m/%d/%Y"), env.opts.autoescape);
;
}
else {
t_9 += "TBD";
;
}
t_9 += "</div>\n                                                        <div class=\"MyADGMeetings-meetingMinutes-listItemTitle\">";
t_9 += runtime.suppressValue(runtime.memberLookup((t_27),"title"), env.opts.autoescape);
t_9 += "</div>\n                                                    </a>\n                                                </li>\n                                            ";
;
}
}
frame = frame.pop();
;
}
}
frame = frame.pop();
t_9 += "</ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ";
;
}
t_9 += "\n\n        <div class=\"MyADGMeetings-listWrapper\">\n            ";
t_9 += runtime.suppressValue((lineno = 88, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MyADGMeetingsInner"), "MyADGMeetingsInner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list")})])), env.opts.autoescape);
t_9 += "\n        </div>\n\n        <div ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasMore")) {
t_9 += "style=\"display:none\"";
;
}
t_9 += " class=\"MyADGMeetings-showMoreButton\">\n            <button>More</button>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MyADGMeetings");
context.setVariable("MyADGMeetings", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGMeetings/MyADGMeetings.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGMeetings/MyADGMeetings.jinja
// module id = 507
// module chunks = 0